<template>
  <div>
    <!-- Nav and Logo
    ==================================================-->
    <nav id="menu-wrap" class="menu-back cbp-af-header">
      <div class="menu-top background-black">
        <div class="container">
          <div class="row">
            <div class="col-6 px-0 px-md-3 pl-1 py-3">
              <span class="call-top">call us:</span>
              <a href="#" class="call-top">+234 02084 461770</a>
            </div>
            <div class="col-6 px-0 px-md-3 py-3 text-right" v-if="userIsNotLoggedIn">
              <a href="#" @click="openLoginModal()" class="lang-wrap">Login/Register</a>
            </div>
            <div v-else class="col-6 px-0 px-md-3 py-3 text-right">
              <a href="#" class="lang-wrap">{{ this.user.email }}</a>
              <a href="#" @click="logout($event)" class="lang-wrap">Logout</a>

            </div>

          </div>
        </div>
      </div>
      <div class="menu">
        <router-link to="/">
          <div class="logo">
            <img src="img/logo.png" alt>
          </div>
        </router-link>
        <ul>
          <li>
            <router-link active-class="currentpage" to="/">home</router-link>
          </li>
          <li>
            <a href="#" class="currentpage" @click="bookNow($event)">Availability</a>
          </li>

          <li>
            <router-link active-class="currentpage" to="/gallery">gallery</router-link>
          </li>

          <li>
            <router-link active-class="currentpage" to="/about">About</router-link>
          </li>
          <li>
            <router-link active-class="currentpage" to="/resturant">Resturant</router-link>
          </li>
          <li>
            <router-link active-class="currentpage" to="/event">Meeting and Events</router-link>
          </li>
          <li>
            <router-link active-class="currentpage" to="/contact-us">contact us</router-link>
          </li>

          <li>
            <a href="#" @click="bookNow($event)">
              <span>book now</span>
            </a>
          </li>
        </ul>
      </div>
    </nav>

    <!-- login and register modal -->
    <!-- ===================================================== -->
    <div
      class="modal fade"
      id="loginRegisterModal"
      aria-labelledby="loginRegisterModal"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Welcome to Ogeyi's place</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <h6>Login to Your Account</h6>
                <form class="mt-4">
                  <div class="form-group">
                    <label for="loginEmail">Email address</label>
                    <input
                      type="email"
                      class="form-control"
                      id="loginEmail"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                      v-model="userEmail"
                    >
                    <small
                      id="emailHelp"
                      class="form-text text-muted"
                    >We'll never share your email with anyone else.</small>
                  </div>
                  <div class="form-group">
                    <label for="password">Password</label>
                    <input
                      type="password"
                      class="form-control"
                      id="password"
                      placeholder="Password"
                      v-model="userPassword"
                    >
                  </div>
                  <div class="form-group form-check">
                    <input type="checkbox" class="form-check-input" id="rememberMe">
                    <label class="form-check-label" for="rememberMe">remember me</label>
                  </div>
                  <button type="submit" class="btn btn-primary" @click="logInUser($event)">Submit</button>
                </form>
              </div>
              <div class="col-md-6">
                <h6>Register</h6>
                <form class="mt-4">
                  <div class="form-group">
                    <label for="fullName">Full Name</label>
                    <input
                      type="text"
                      class="form-control"
                      id="fullName"
                      aria-describedby="fullName"
                      placeholder="Enter Your Full name"
                      v-model="fullName"
                    >
                  </div>

                  <div class="form-group">
                    <label for="registerEmail">Email address</label>
                    <input
                      type="email"
                      class="form-control"
                      id="registerEmail"
                      aria-describedby="registerEmail"
                      placeholder="Enter email"
                      v-model="email"
                    >
                    <small
                      id="registerEmailHelp"
                      class="form-text text-muted"
                    >We'll never share your email with anyone else.</small>
                  </div>
                  <div class="form-group">
                    <label for="registerPassword">Password</label>
                    <input
                      type="password"
                      class="form-control"
                      id="registerPassword"
                      placeholder="Password"
                      v-model="password"
                    >
                  </div>

                  <div class="form-group">
                    <label for="confirmPassword">Confirm Password</label>
                    <input
                      type="password"
                      class="form-control"
                      id="confirmPassword"
                      placeholder="Password"
                      v-model="confirmPassword"
                    >
                  </div>

                  <button type="submit" class="btn btn-primary" @click="registerUser($event)">Submit</button>
                </form>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <!-- <button type="button" class="btn btn-primary">Save changes</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import constants from '@/common/Constants.js'
export default {
  name: "headerNav",
  data(){
      return{
        userIsNotLoggedIn: true,
          userEmail: '',
          userPassword: '',

          fullName: '',
          email: '',
          password: '',
          confirmPassword: '',
          user: {}

      }
  },
  mounted() {

    if(localStorage.user){
      let userDetails = JSON.parse(localStorage.user);

      this.userIsNotLoggedIn = false;
      this.user = userDetails;
    }else{
      localStorage.user ='';
      this.userIsNotLoggedIn = true;
      this.user = {}
    }
    cbpAnimatedHeader = (function() {
      function e() {
        window.addEventListener(
          "scroll",
          function(e) {
            c || ((c = !0), setTimeout(n, 250));
          },
          !1
        );
      }

      function n() {
        var e = s();
        e >= i
          ? classie.add(t, "cbp-af-header-shrink")
          : classie.remove(t, "cbp-af-header-shrink"),
          (c = !1);
      }

      function s() {
        return window.pageYOffset || a.scrollTop;
      }
      var a = document.documentElement,
        t = document.querySelector(".cbp-af-header"),
        c = !1,
        i = 100;
      e();
    })();

  },
  methods: {
    openLoginModal() {
      $("#loginRegisterModal").modal("toggle");
    },
    logInUser(event){
      event.preventDefault();
      if (this.userEmail != '' && this.userPassword != ''){

        let url = constants.API_USER_LOGIN_URL;
        let requestBody = {
          email: this.userEmail,
          password: this.userPassword
        }

        this.$http.post(url, requestBody)
        .then((result) => {

          this.userIsNotLoggedIn = false
          localStorage.user = JSON.stringify(result.data.user);
          localStorage.userToken = result.data.user.token;
          this.user = result.data.user;

          $("#loginRegisterModal").modal("toggle");

        })
        .catch(function (error) {
          if (error.response) {

            if(error.response.status == 401){
              alert('wrong user name or password')
            }else if(error.response.status == 500){
                var message = "Unable to complete request."
                alert(message);
            }

          }
        });

        // $.post(url, requestBody, function(data){

        //   console.log(data);
        //   localStorage.user = JSON.stringify(data.user);

        //   // userDetails = localStorage.user;

        //   // localStorage.token = data.user.token;
        //   // loginStatus = false;
        // })
        // .fail(function(jqXHR, textStatus, error) {
        //     console.log(jqXHR)
        //   if(jqXHR.status == 401){
        //       alert('wrong user name or password')
        //   }else if(jqXHR.status == 500){
        //       var message = "Unable to complete request."
        //       alert(message);
        //   }

        // });
      }
    },
    registerUser(event){
      event.preventDefault();

      let requestBody = {
        name: this.fullName,
        email: this.email,
        password: this.password,
        confirm_password: this.confirmPassword
      }
      let userDetails = this.user;

      if( this.validateRegistrationDetails(requestBody) ){

        let url = constants.API_USER_REGISTER_URL;
        let requestBody = {
          email: this.email,
          password: this.password,
          name: this.fullName,
          confirm_password: this.confirmPassword
        }

        this.$http.post(url, requestBody)
        .then((result) => {

          this.userIsNotLoggedIn = false
          localStorage.user = JSON.stringify(result.data.user);
          localStorage.userToken = result.data.user.token;
          this.user = result.data.user;

          $("#loginRegisterModal").modal("toggle");

        })
        .catch(function (error) {
          if (error.response) {

            if(error.response.status == 401){
              alert('failed validation')
            }else if(error.response.status == 500){
                var message = "Unable to complete request."
                alert(message);
            }

          }
        });


      }
    },
    logout(event){
      event.preventDefault();

      this.$http.get(constants.API_USER_LOGOUT_URL, { headers: { Authorization: "Bearer " + this.user.token }})
      .then(response => {
        this.userIsNotLoggedIn = true;
        localStorage.clear();

      })
      .catch(error => {
        console.log(error)
      })


    },
    bookNow(event){
       event.preventDefault();
       localStorage.queryData = '';
       localStorage.rooms = '';
        this.$router.push('rooms');

    },

    validateRegistrationDetails(requestBody){
      if(
        this.fullName != '' &&
        this.email != '' &&
        this.password != '' &&
        this.confirmPassword != ''&&
        this.password == this.confirmPassword &&
        this.password.length > 5
      ){

        return true;
      }else{

        return false;
      }
    }
  },
  props: {
    msg: String
  }
};
</script>

